import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialReactTable from "material-react-table";
import { Chip, Grid } from "@mui/material";
import { AppDispatch } from "src/store";
import { selectLeads } from "src/slices/leads/selectors";
import { fetchLeads } from "src/slices/leads/thunk";
import { ILead } from "src/slices/leads/type";
import { LeadsTableActionBar } from "./lead-table-action-bar";
import { LeadsTableActionMenu } from "./lead-table-action-menu";
import { fetchLocations } from "src/slices/configuration/thunks";
import { selectLocations } from "src/slices/configuration/selectors";

export function LeadListing() {
  const dispatch = useDispatch<AppDispatch>();
  const leads = useSelector(selectLeads);
  const locations = useSelector(selectLocations);
  // console.log("locations", locations);

  const [columns] = useState<any>([
    {
      accessorKey: "leadFullName",
      header: "Name",
    },
    {
      accessorKey: "contactNumber",
      header: "Contact Number",
    },
    {
      accessorKey: "leadChannel",
      header: "Lead Channel",
    },
    {
      accessorKey: "leadBranch",
      header: "Branch",
    },
    {
      accessorKey: "lastModifiedByName",
      header: "Created By",
    },
    {
      accessorKey: "createdAt",
      header: "Created Date",
    },
    {
      accessorKey: "IsCustomer",
      header: "Is Customer",
      Cell: ({ cell }) => (
        <Chip
          label={cell.getValue() === false ? "NO" : "YES"}
          variant="filled"
          color={cell.getValue() === false ? "error" : "success"}
          sx={{ minWidth: 50 }}
        />
      ),
    },
  ]);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    dispatch(fetchLeads());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(fetchLocations());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leads && leads.length > 0) {
      const tableRows = leads?.map((lead: ILead) => {
        const branch = locations.find(
          (loc) => Number(loc.id) === Number(lead.branchId)
        );
        // console.log("branch", branch);

        return {
          id: lead.id,
          leadFullName: lead.name,
          contactNumber: lead.primaryNumber,
          IsCustomer: lead.isCustomer,
          leadChannel: lead.leadChannel,
          leadBranch: branch ? branch.name : "N/A",
          isActive: lead.isActive,
          lastModifiedByName: lead.lastModifiedByName,
          createdAt: lead.createdAt
            ? new Date(lead.createdAt).toLocaleDateString()
            : "N/A",
        };
      });
      setRows(tableRows);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leads]);

  return (
    <Box sx={{ width: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MaterialReactTable
            columns={columns}
            data={rows}
            initialState={{
              density: "compact",
              pagination: { pageIndex: 0, pageSize: 100 },
            }}
            renderTopToolbarCustomActions={LeadsTableActionBar}
            enableRowActions
            renderRowActionMenuItems={LeadsTableActionMenu}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
